(function (document) {
  const customizer = document.querySelector('.product-customizer');
  // If no customizer found on the page, do nothing.
  if (!customizer) return;

  init();

  function init() {
    customizer.addEventListener('change', (event) => {
      const swatch = event.target;
      if (swatch.dataset.planoRelationshipLens &&
          customizer.dataset.customizerState === 'plano') {
        updatePlanoRelationship(swatch);
      }

      if (customizer.dataset.customizerState === 'custom') {
        updateExcludedLenses(swatch);
      }

      broadcastSelections();
    });

    if (customizer.querySelectorAll('.swatch-list__toggle:checked').length) {
      customizer.dataset.customizerState = 'custom';
    }

    if (typeof componentEvents !== 'undefined') {
      componentEvents.on('swatch-list-toggle', updateCustomizerState);
    }

    window.addEventListener('load', () => {
      updateExcludedLenses(customizer.querySelector('[data-frame-color-id]:checked'));
    });
  }

  /**
   * Auto-select the lens color associated with a given frame color.
   */
  function updatePlanoRelationship(swatch) {
    const relatedId = swatch.dataset.planoRelationshipLens;
    const relatedSwatches = customizer.querySelectorAll(`[data-lens-color-id="${relatedId}"]`);
    relatedSwatches.forEach((relatedSwatch) => {
      relatedSwatch.checked = true;
      emitChangeEvent(relatedSwatch);
    });
  }

  /**
   * Update the state of the customizer component.
   */
  function updateCustomizerState(data) {
    const { feature, state } = data;
    // If the toggled list is not concerned with the lens-color or clip-on-color, do nothing.
    if (feature !== 'lens-color' && feature !== 'clip-on-color') return;
    // Determine whether any of the swatch lists are expanded.
    const swatchListsExpanded = !!customizer
      .querySelectorAll('[data-swatch-list-expanded="true"]').length;
    if (swatchListsExpanded) {
      customizer.dataset.customizerState = 'custom';
      // Update excluded lenses according to whichever frame is selected.
      updateExcludedLenses(customizer.querySelector('[data-frame-color-id]:checked'));
    } else {
      customizer.dataset.customizerState = 'plano';
      // When switching back to plano mode, we trigger the selected frame
      // swatch’s change event to ensure its related lens color is selected.
      const selectedFrameSwatch = customizer
        .querySelector('[data-plano-relationship-lens]:checked');
      if (!selectedFrameSwatch) return;
      // Wait for the collapse animation to end before emitting the event.
      setTimeout(emitChangeEvent, 250, selectedFrameSwatch);
      // Wait for the collapse animation to end before enabling all swatches.
      setTimeout(() => {
        customizer.querySelectorAll('.swatch')
          .forEach(swatch => swatch.disabled = false);
      }, 250);
    }
  }

  /**
   * Update any swatches that cannot be combined with the selected swatch.
   */
  function updateExcludedLenses(swatch) {
    const featureContainer = swatch.closest('[data-swatch-list-feature]');
    // If no feature container is found, do nothing.
    if (!featureContainer) return;

    // Only frame swatches own the "exclude" relationship. If this is a frame
    // swatch list, we find all the lenses and clip on lenses, and disable them
    // if they're in the selected frame's exclude list.
    if (featureContainer.dataset.swatchListFeature === 'frame-color') {
      const allLenses = customizer.querySelectorAll('[data-lens-color-id]');
      const allClipOnLenses = customizer.querySelectorAll('[data-clip-on-color-id]');
      const excludedLenses = (swatch.dataset.customExcludeLens || '').split(':');
      allLenses.forEach((lensSwatch) => {
        // Disable the lens swatch if it is in the array of excluded lenses.
        lensSwatch.disabled = excludedLenses.indexOf(lensSwatch.dataset.lensColorId) > -1;
        if (lensSwatch.disabled) {
          const tooltipOptions = {
            tooltipParent: getTooltipParent(lensSwatch),
            tooltipModifiers: ['tooltip--alternate'],
            tooltipIcon: true,
          };
          componentEvents.emitEvent('tooltip-build', [tooltipOptions]);
        } else {
          componentEvents.emitEvent('tooltip-destroy', [getTooltipParent(lensSwatch)]);
        }
      });
      allClipOnLenses.forEach((clipOnSwatch) => {
        // Disable the clip on lens swatch if it is in the array of excluded lenses.
        clipOnSwatch.disabled = excludedLenses.indexOf(clipOnSwatch.dataset.clipOnColorId) > -1;
        if (clipOnSwatch.disabled) {
          const tooltipOptions = {
            tooltipParent: getTooltipParent(clipOnSwatch),
            tooltipModifiers: ['tooltip--alternate'],
            tooltipIcon: true,
          };
          componentEvents.emitEvent('tooltip-build', [tooltipOptions]);
        } else {
          componentEvents.emitEvent('tooltip-destroy', [getTooltipParent(clipOnSwatch)]);
        }
      });

    // If this is a lens swatch list, find all the frames and disable those
    // according to the `data-custom-exclude` value of the frame.
    } else if (featureContainer.dataset.swatchListFeature === 'lens-color') {
      const lensId = swatch.dataset.lensColorId;
      const regex = swatchIdMatch(lensId);
      const allFrames = customizer.querySelectorAll('[data-frame-color-id]');
      allFrames.forEach((frameSwatch) => {
        // Disable the frame if the selected lens is in its excluded lenses.
        frameSwatch.disabled = !!((frameSwatch.dataset.customExcludeLens || '').match(regex));
        if (frameSwatch.disabled) {
          const tooltipOptions = {
            tooltipParent: getTooltipParent(frameSwatch),
            tooltipModifiers: ['tooltip--alternate'],
            tooltipIcon: true,
          };
          componentEvents.emitEvent('tooltip-build', [tooltipOptions]);
        } else {
          componentEvents.emitEvent('tooltip-destroy', [getTooltipParent(frameSwatch)]);
        }
      });

    // If this is a clip-on lens  swatch list, find all the frames and disable
    // those according to the `data-custom-exclude` value of the frame.
    } else if (featureContainer.dataset.swatchListFeature === 'clip-on-color') {
      const clipOnId = swatch.dataset.clipOnColorId;
      const regex = swatchIdMatch(clipOnId);
      const allFrames = customizer.querySelectorAll('[data-frame-color-id]');
      allFrames.forEach((frameSwatch) => {
        // Disable the frame if the selected clip on lens is in its excluded lenses.
        frameSwatch.disabled = !!((frameSwatch.dataset.customExcludeLens || '').match(regex));
        if (frameSwatch.disabled) {
          const tooltipOptions = {
            tooltipParent: getTooltipParent(frameSwatch),
            tooltipModifiers: ['tooltip--alternate'],
            tooltipIcon: true,
          };
          componentEvents.emitEvent('tooltip-build', [tooltipOptions]);
        } else {
          componentEvents.emitEvent('tooltip-destroy', [getTooltipParent(frameSwatch)]);
        }
      });
    }
  }

  /**
   * The regex generated here ensures the ID match is exact, preventing false
   * positives when IDs contain the same values, such as `neutral-grey` vs
   * `neutral-grey-clip`.
   */
  function swatchIdMatch(itemId) {
    return new RegExp(`(?:^|:)${itemId}(?::|$)`);
  }

  // Get the parent item to append the tooltip to.
  function getTooltipParent(swatch) {
    return document.querySelector(`label[for="${swatch.id}"]`);
  }

  /**
   * Broadcast currently selected options within customizer.
   */
  function broadcastSelections() {
    if (typeof componentEvents !== 'undefined') {
      const apparelColor = customizer.querySelector('[data-apparel-color-id]:checked');
      const apparelSize = customizer.querySelector('[data-apparel-size-id]:checked');
      const clipOnColor = customizer.querySelector('[data-clip-on-color-id]:checked');
      const clipOnEnabled = customizer.querySelector('[data-clip-on-enabled]');
      const frameColor = customizer.querySelector('[data-frame-color-id]:checked');
      const lensColor = customizer.querySelector('[data-lens-color-id]:checked');
      const readerPower = customizer.querySelector('[data-reader-power]');
      componentEvents.emitEvent('product-options-updated', [{
        apparelColor: apparelColor ? apparelColor.value : null,
        apparelSize: apparelSize ? apparelSize.value : null,
        clipOnColor: clipOnColor ? clipOnColor.value : null,
        clipOnEnabled: clipOnEnabled ? clipOnEnabled.checked : null,
        frameColor: frameColor ? frameColor.value : null,
        lensColor: lensColor ? lensColor.value : null,
        readerPower: readerPower ? readerPower.value : null,
      }]);
    }
  }

  /**
   * Dispatch a change event the modern way, falling back the old-school way.
   */
  function emitChangeEvent(swatch) {
    try {
      swatch.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (error) {
      const event = document.createEvent('HTMLEvents');
      event.initEvent('change', true, false);
      swatch.dispatchEvent(event);
    }
  }
})(document);
